import en from './en.json';
import zhCN from './zh-cn.json';
import zhTW from './zh-tw.json';
import jp from './jp.json';

export default {
  en,
  'zh-cn': zhCN,
  'zh-tw': zhTW,
  jp,
};



// WEBPACK FOOTER //
// ./src/assets/locales/index.js